export default "__VITE_ASSET__CEmx326o__"